import { type ReactNode, useContext } from 'react';
import { createRegisteredContext } from 'react-singleton-context';

import { type TranslationKey } from '../../utils/translations/defaultTranslations';

interface Currency {
  code: string;
  separator: {
    decimal: string;
    thousands: string;
  };
  decimalScale: number;
  symbol: string;
  symbolPosition: 'before' | 'after';
}

interface AhoyConfig {
  language?: string;
  currencies?: Currency[];
  translate?: (key: TranslationKey, variables?: Record<string, string | number>) => string | null;
  components?: {
    Overlay?: {
      className?: string;
    };
    SidePanel?: {
      className?: string;
    };
  };
}

interface AhoyProviderProps {
  config: AhoyConfig;
  children: ReactNode;
}

const AhoyContext = createRegisteredContext<AhoyConfig>('AhoyContext', {});

export const useAhoyConfig = () => {
  const config = useContext(AhoyContext);

  return config;
};

const AhoyProvider = ({ config, children }: AhoyProviderProps) => {
  return <AhoyContext.Provider value={config}>{children}</AhoyContext.Provider>;
};

export default AhoyProvider;
